import { Typography } from '@material-ui/core';
import { css } from '@emotion/react';
import { useColors } from 'hooks/useColors';
import { i18n } from 'lib/i18n';
import { unsanitized } from 'styles/utils';
import { sanitize } from 'lib/form';
import { IColors } from 'types/colors';
import SubTitle from 'components/shared/Title/SubTitle';

const longDescriptionCss = (colors: IColors) => css`
	overflow-wrap: break-word;
	font-size: 1.4rem;
	font-weight: 600;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.5 !important;
	letter-spacing: normal;
	color: ${colors.tx_text_primary};
	a {
		color: ${colors.tx_text_primary};
		text-decoration: underline;
	}
	${unsanitized}
`;

const longDescriptionWrapperCss = css`
	margin-bottom: 52px;
`;
interface Props {
	title: string;
	description?: string;
}

function LongDescription({ description, title }: Props) {
	const { colors } = useColors();
	return (
		<>
			{description && (
				<>
					<SubTitle text={`${i18n.longDescriptionTitle} ${title}`} />

					<div css={longDescriptionWrapperCss}>
						<Typography
							css={longDescriptionCss(colors)}
							dangerouslySetInnerHTML={{
								__html: sanitize(description),
							}}
						/>
					</div>
				</>
			)}
		</>
	);
}

export default LongDescription;
